<template>
	<div
		ref="dropdown"
		class="w-100 hebergement-dropdown py-3 px-4"
		@click.stop="() => {}"
	>
		<div v-for="option in totalAvailable" :key="option">
			<template v-if="option <= maximum">
				<div class="mx-3" v-if="option !== 1"></div>
				<div
					@click.stop="() => handleClick(option)"
					class="cursor-pointer col-12 d-flex flex-row justify-content-start px-0 m-3 align-items-center hebergement-row-container"
				>
					<div
						:class="checkIsSelected(option) && 'active'"
						class="hebergement-row-checkbox me-2 ts-form-check-input border-primary-blue mb-1"
					></div>
					<div
						class="body text-start"
						:class="checkIsSelected(option) && 'body-strong text-primary-blue'"
					>
						<span class="d-flex flex-row nowrap">
							<span class="me-1">{{ option }}</span>
							<span v-if="option === 1">
								{{ content.planningResult_hebergement}}
							</span>
							<span v-else>
								<template v-if="accommodationOnly">
									{{ content.planningResult_hebergements_abbreviated }} 
									(+ {{ accommodationCalculationWithCurrency(option) }})
								</template>
								<template v-else>
									{{ content.planningResult_hebergements }}
								</template>
							</span>
						</span>
					</div>
				</div>
			</template>
		</div>
	</div>
</template>

<script lang="ts" setup>
import {
	watch,
	ref,
	Ref,
	nextTick,
	computed,
} from "vue"
import displayPrice from "@/displayPrice/displayPrice"

// content
const content = window.content

// Props
interface Props {
	selected: number
	open: boolean
	totalAvailable: number
	speed: number
	maximum: number
	locale: string
	accommodationOnly: string | undefined
}

const props = withDefaults(defineProps<Props>(), {
	selected: 1,
	open: false,
	totalAvailable: 1,
	speed: 100,
	maximum: 20,
})

// Template refs
const dropdown: Ref<HTMLDivElement | null> = ref(null)

// Emits
const emit = defineEmits<{
	(e: "select", value: number): void
}>()

const handleClick = (newSelected: number): void => {
	emit("select", newSelected)
}

const fadeIn = (display = "block"): void => {
	if (!dropdown.value) return

	const value = dropdown.value
	value.style.display = display

	nextTick(() => {
		value.style.opacity = "1"
	})
}
const fadeOut = (): void => {
	if (!dropdown.value) return
	const value = dropdown.value

	value.style.opacity = "0"
	setTimeout(() => {
		value.style.display = "none"
	}, props.speed)
}

const checkIsSelected = (index: number): boolean => {
	return index === props.selected
}

const accommodationCalculationWithCurrency = computed(() => (option: number) => {
	if (!props.accommodationOnly) return ''
	return displayPrice(parseInt(props.accommodationOnly)*(option-1)*100, props.locale);
})

// Watchers
watch(
	() => props.open,
	(newVal, oldVal) => {
		if (newVal && !oldVal) {
			fadeIn()
		} else if (!newVal && oldVal) {
			fadeOut()
		}
	}
)
</script>

<style scoped>
.hebergement-row-container:hover {
	color: var(--primary-blue);
}
.hebergement-dropdown:hover {
	box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.26);
}

.hebergement-dropdown {
	/* min-width: 250px; */
	display: none;
    opacity: 0;
	border-radius: 8px;
	position: absolute;
	bottom: -5px;
	right: 0px;
	transform: translateY(100%);
	z-index: 5;
	background: white;
	box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.13);
	transition: box-shadow 150ms ease-in-out;
	overflow-y: auto;
	overflow-x: hidden;
	max-height: 260px;
}

.hebergement-row-checkbox {
	border-radius: 0.25em;
	transition: border 100ms ease-in-out;
}

.hebergement-row-checkbox.active {
	border: 5px solid var(--primary-blue);
	background-color: var(--primary-blue);
	border-color: var(--primary-blue);
	background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e");
}

.hebergement-dropdown {
  /* reset to your normal body text color */
  color: var(--primary-text, #212529);
}
</style>
